import { DsText } from '@mvp/design-system';
import React, { FC } from 'react';
import { formatToDollarAmount } from '../../../utils/string';
import { useTranslation } from 'react-i18next';

interface RxCoverageProps {
  rxCoverageGeneric: string;
  rxCoveragePreferred: string;
  rxCoverageNonPreferred: string;
  isMobile?: boolean;
}

const RxCoverage: FC<RxCoverageProps> = ({ rxCoverageGeneric, rxCoveragePreferred, rxCoverageNonPreferred, isMobile = false }) => {
  const { t } = useTranslation();
  
  const rxCoverageGenericAmount = rxCoverageGeneric.split(' ')[0];
  const rxCoveragePreferredAmount = rxCoveragePreferred.split(' ')[0];
  const rxCoverageNonPreferredAmount = rxCoverageNonPreferred.split(' ')[0];

  return (
    <>
      <DsText variant='overline' text={t('planDetails.rxCoverage')} />
      <DsText variant="body2" text={`${formatToDollarAmount(rxCoverageGenericAmount)} / ${formatToDollarAmount(rxCoveragePreferredAmount)} / ${formatToDollarAmount(rxCoverageNonPreferredAmount) } Co-pay`} />
      <DsText variant="caption" text={!isMobile ? t('planDetails.rxType') : t('planDetails.abbreviated.rxType')} />
    </>
  )
}

export default RxCoverage